import {  useState } from "react";
import ImageUploader from "../../../components/image-uploader";

import { Button, Form, Input } from "antd";
import { ModalComponent } from "../../../components";
import { useCategories } from "../../../hooks";

const CreateCategoryForm = ({ initialValues, onSubmit }) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { createCategory, } = useCategories({ autoFetch: false });

  const handleFinish = async (values) => {
    const response = await createCategory({ values });
    if (response != null) {
      onSubmit(response);
      setIsModalOpen(false);
    }
    form.resetFields();
  };

  return (
    <ModalComponent
      title="Crear Categoría"
      isModalOpen={isModalOpen}
      setOpen={setIsModalOpen}
      modalContent={
        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => handleFinish(values)}
        >
          <Form.Item
            name="name"
            label="Nombre"
            rules={[{ required: true, message: "Requerido" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="type"
            label="Tipo"
            rules={[{ required: true, message: "Requerido" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Descripción"
            rules={[{ required: true, message: "Requerido" }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
          <Form.Item
            name="image"
            label="Imagen"
            // rules={[{ required: true, message: "Requerido" }]}
            valuePropName="fileList"
            getValueFromEvent={(e) => e.fileList}
          >
            <ImageUploader
              onSaved={(imageUrl) => form.setFieldsValue({ image: imageUrl })}
            />
          </Form.Item>
          {initialValues && initialValues.image && (
            <img
              src={initialValues.image}
              alt={initialValues.name}
              style={{ width: 100, marginBottom: 10 }}
            />
          )}
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {initialValues ? "Guardar" : "Agregar"}
            </Button>
          </Form.Item>
        </Form>
      }
    >
      <Button type="primary" style={{ marginTop: 10 }}>
        Agregar Categoría
      </Button>
    </ModalComponent>
  );
};

export default CreateCategoryForm;
